export const PLANING_TEAM_GENERAL_TAB = "general";
export const PLANING_TEAM_WORK_SHIFT_TAB = "workshift";
export const PLANING_TEAM_ABSENSE_TAB = "absences";
